import { render, staticRenderFns } from "./IntegralADList.vue?vue&type=template&id=bb17d208&"
import script from "./IntegralADList.vue?vue&type=script&lang=js&"
export * from "./IntegralADList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports